import useDeprecateExamination from './useDeprecateExamination';

export default useDeprecateExamination;
